import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const VALEURS = [
  { icon: "⭐", title: "Excellence", desc: "Nous livrons des prestations irréprochables à chaque intervention, sans compromis sur la qualité." },
  { icon: "🤝", title: "Intégrité", desc: "Transparence et honnêteté guident chacune de nos relations clients et partenaires." },
  { icon: "💡", title: "Innovation", desc: "Nous adoptons les meilleures technologies et méthodes pour rester à la pointe." },
  { icon: "🌱", title: "Durabilité", desc: "Produits écologiques et pratiques responsables pour préserver notre environnement." },
  { icon: "❤️", title: "Proximité", desc: "Nous construisons des relations durables basées sur l'écoute et la confiance." },
];

const TIMELINE = [
  { year: "2022", title: "Fondation du Groupe", desc: "Création de PurePro Group à Abidjan avec une vision : devenir le groupe de services de référence en Côte d'Ivoire.", dot: "#c9a227" },
  { year: "2022", title: "Lancement PureProTechnologie", desc: "Lancement de l'entité tech pour accompagner la transformation digitale des entreprises ivoiriennes.", dot: "#f97316" },
  { year: "2024", title: "Création PureProCleaners", desc: "Ouverture de l'entité nettoyage professionnel : nettoyage, piscines, climatisation et traitement 3D.", dot: "#2d9b5c" },
  { year: "2025", title: "Extension & Croissance", desc: "Extension des activités sur tout le territoire national. Développement du portefeuille client.", dot: "#3b6bff" },
  { year: "2026", title: "20+ Projets livrés", desc: "Plus de 20 projets réalisés, 100% de clients satisfaits, présence renforcée en Afrique de l'Ouest.", dot: "#c9a227" },
];

const TEAM = [
  { name: "Direction Générale", role: "Stratégie & Vision", color: "#c9a227", initial: "DG" },
  { name: "PureProCleaners", role: "Direction Nettoyage", color: "#2d9b5c", initial: "PC" },
  { name: "PureProTechnologie", role: "Direction Tech & Digital", color: "#f97316", initial: "PT" },
  { name: "Commercial & Marketing", role: "Développement Business", color: "#3b6bff", initial: "CM" },
];

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
}

export default function About() {
  const [heroRef, heroVisible] = useInView(0.1);
  const [missionRef, missionVisible] = useInView(0.1);
  const [valeursRef, valeursVisible] = useInView(0.1);
  const [timelineRef, timelineVisible] = useInView(0.1);

  return (
    <div className="about-page">
      {/* Styles responsifs - tout en classes */}
  

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="container">
          <div className="hero-content" style={{ opacity: heroVisible ? 1 : 0, transform: heroVisible ? "translateY(0)" : "translateY(30px)", transition: "all .7s ease" }}>
            <span className="section-tag">À propos de nous</span>
            <h1 className="hero-title">Un groupe, <span style={{ color: "#c9a227" }}>deux expertises,</span><br />une vision commune</h1>
            <p className="hero-sub">PurePro Group est le fruit d'une ambition ivoirienne : réunir sous un même toit le meilleur du nettoyage professionnel et de la transformation digitale pour servir les entreprises de Côte d'Ivoire.</p>
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
              <Link to="/services" className="btn btn-primary">Nos services →</Link>
              <Link to="/contact" className="btn btn-outline">Nous contacter</Link>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION / VISION */}
      <section className="section" ref={missionRef}>
        <div className="container">
          <div className="mv-grid" style={{ opacity: missionVisible ? 1 : 0, transform: missionVisible ? "translateY(0)" : "translateY(30px)", transition: "all .7s ease" }}>
            {/* Mission */}
            <div className="mv-card">
              <div className="mv-icon" style={{ background: "rgba(201,162,39,.1)", border: "1.5px solid rgba(201,162,39,.3)" }}>
                <span style={{ fontSize: "28px" }}>🎯</span>
              </div>
              <h2 className="mv-title">Notre Mission</h2>
              <div className="gold-line"></div>
              <p className="mv-text">Délivrer des prestations d'excellence qui améliorent la qualité de vie et accélèrent la transformation digitale de nos clients en Côte d'Ivoire et en Afrique de l'Ouest.</p>
              <ul className="mv-list">
                <li className="mv-item"><span className="mv-bullet"></span>Qualité irréprochable à chaque prestation</li>
                <li className="mv-item"><span className="mv-bullet"></span>Solutions adaptées aux réalités locales</li>
                <li className="mv-item"><span className="mv-bullet"></span>Accompagnement personnalisé et durable</li>
              </ul>
            </div>
            {/* Vision */}
            <div className="mv-card vision" style={{ background: "linear-gradient(135deg, #0a2540 0%, #1e3a5f 100%)" }}>
              <div className="mv-icon" style={{ background: "rgba(201,162,39,.15)", border: "1.5px solid rgba(201,162,39,.4)" }}>
                <span style={{ fontSize: "28px" }}>🌍</span>
              </div>
              <h2 className="mv-title" style={{ color: "#fff" }}>Notre Vision</h2>
              <div className="gold-line"></div>
              <p className="mv-text" style={{ color: "rgba(255,255,255,.7)" }}>Devenir le groupe de services de référence en Afrique de l'Ouest, reconnu pour son excellence opérationnelle, son innovation continue et son impact positif sur les communautés.</p>
              <div className="vision-stats">
                {[{ n: "20+", l: "Projets livrés" }, { n: "100%", l: "Satisfaction" }, { n: "2", l: "Entités" }].map(({ n, l }) => (
                  <div key={l} className="v-stat">
                    <div className="v-stat-num">{n}</div>
                    <div className="v-stat-label">{l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VALEURS */}
      <section className="section" style={{ background: "#f8f9fc" }} ref={valeursRef}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: "56px", opacity: valeursVisible ? 1 : 0, transform: valeursVisible ? "translateY(0)" : "translateY(20px)", transition: "all .6s ease" }}>
            <span className="section-tag">Ce qui nous définit</span>
            <h2 className="section-title">Nos <span>valeurs fondatrices</span></h2>
            <p className="section-sub">Cinq valeurs qui guident chacune de nos décisions et façonnent notre culture d'entreprise au quotidien.</p>
          </div>
          <div className="valeurs-grid">
            {VALEURS.map((v, i) => (
              <div key={v.title} className="card val-card" style={{ opacity: valeursVisible ? 1 : 0, transform: valeursVisible ? "translateY(0)" : "translateY(30px)", transition: `all .6s ease ${i * .1}s` }}>
                <div className="val-icon">{v.icon}</div>
                <h3 className="val-title">{v.title}</h3>
                <p className="val-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="section" ref={timelineRef}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: "60px", opacity: timelineVisible ? 1 : 0, transition: "all .6s ease" }}>
            <span className="section-tag">Notre parcours</span>
            <h2 className="section-title">L'histoire de <span>PurePro Group</span></h2>
            <p className="section-sub">De l'idée à l'excellence — notre chemin depuis la fondation.</p>
          </div>
          <div className="timeline">
            {TIMELINE.map((item, i) => (
              <div key={i} className="timeline-item" style={{ opacity: timelineVisible ? 1 : 0, transform: timelineVisible ? "translateX(0)" : `translateX(${i % 2 === 0 ? "-30px" : "30px"})`, transition: `all .6s ease ${i * .15}s` }}>
                <div className="tl-card">
                  <div className="tl-year" style={{ color: item.dot }}>{item.year}</div>
                  <h3 className="tl-title">{item.title}</h3>
                  <p className="tl-desc">{item.desc}</p>
                </div>
                <div className="tl-center">
                  <div className="tl-dot" style={{ background: item.dot, boxShadow: `0 0 0 4px rgba(255,255,255,1), 0 0 0 7px ${item.dot}40` }} />
                  <div className="tl-line"></div>
                </div>
                <div style={{ flex: 1 }}></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="section" style={{ background: "#f8f9fc" }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: "48px" }}>
            <span className="section-tag">Notre organisation</span>
            <h2 className="section-title">Une équipe <span>structurée</span></h2>
          </div>
          <div className="team-grid">
            {TEAM.map((t) => (
              <div key={t.name} className="card team-card">
                <div className="team-avatar" style={{ background: `${t.color}18`, border: `2px solid ${t.color}50`, color: t.color }}>
                  {t.initial}
                </div>
                <div className="team-name">{t.name}</div>
                <div className="team-role">{t.role}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="section cta-section">
        <div className="container text-center">
          <span className="section-tag">Travaillons ensemble</span>
          <h2 className="cta-title">Prêt à démarrer <span style={{ color: "#c9a227" }}>votre projet ?</span></h2>
          <p className="cta-sub">Contactez-nous pour discuter de vos besoins. Réponse garantie sous 24h.</p>
          <div className="cta-buttons" style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap", marginTop: "32px" }}>
            <Link to="/devis" className="btn btn-primary">Demander un devis gratuit</Link>
            <Link to="/contact" className="btn btn-outline">Nous contacter</Link>
          </div>
        </div>
      </section>
          <style>{`
        /* ---------- RESET & GLOBAL ---------- */
        .about-page {
          padding-top: 72px;
        }
        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }
        .section {
          padding: 80px 0;
        }
        .section-tag {
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #c9a227;
          margin-bottom: 12px;
          display: inline-block;
        }
        .section-title {
          font-size: 36px;
          font-weight: 800;
          color: #0a2540;
          margin-bottom: 16px;
          font-family: 'Playfair Display', serif;
        }
        .section-title span {
          color: #c9a227;
        }
        .section-sub {
          font-size: 16px;
          color: #4a5a6a;
          max-width: 700px;
          line-height: 1.7;
          margin: 0 auto;
        }
        .gold-line {
          width: 60px;
          height: 3px;
          background: #c9a227;
          margin: 16px 0 20px;
        }
        .gold-line.center {
          margin-left: auto;
          margin-right: auto;
        }
        .text-center {
          text-align: center;
        }
        .btn-primary, .btn-outline {
          display: inline-block;
          border-radius: 40px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.2s;
          cursor: pointer;
          text-align: center;
          padding: 12px 28px;
          font-size: 14px;
        }
        .btn-primary {
          background: #c9a227;
          color: #0a2540;
          border: none;
        }
        .btn-primary:hover {
          background: #b38c1a;
          transform: translateY(-2px);
        }
        .btn-outline {
          background: transparent;
          border: 1.5px solid rgba(255,255,255,0.4);
          color: white;
        }
        .btn-outline:hover {
          border-color: #c9a227;
          background: rgba(201,162,39,0.1);
        }
        .card {
          background: #fff;
          border-radius: 20px;
          border: 1px solid #d8e0e8;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px rgba(10,37,64,.12);
        }

        /* ---------- HERO ---------- */
        .hero {
          min-height: 500px;
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          background: linear-gradient(135deg, #0a2540 0%, #0d2d4f 50%, #1e3a5f 100%);
          padding: 80px 0;
        }
        .hero-bg {
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 70% 50%, rgba(201,162,39,.08) 0%, transparent 60%);
        }
        .hero-content {
          max-width: 700px;
          position: relative;
          z-index: 2;
        }
        .hero-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(32px, 5vw, 52px);
          font-weight: 700;
          color: #fff;
          line-height: 1.2;
          margin: 16px 0 20px;
        }
        .hero-sub {
          font-size: 17px;
          color: rgba(255,255,255,.7);
          line-height: 1.8;
          margin-bottom: 32px;
          max-width: 580px;
        }

        /* ---------- MISSION / VISION ---------- */
        .mv-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 32px;
        }
        .mv-card {
          background: #fff;
          border-radius: 20px;
          border: 1px solid #d8e0e8;
          padding: 40px 36px;
          box-shadow: 0 4px 24px rgba(10,37,64,.08);
        }
        .mv-card.vision {
          background: linear-gradient(135deg, #0a2540 0%, #1e3a5f 100%);
        }
        .mv-icon {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
        }
        .mv-title {
          font-family: 'Playfair Display', serif;
          font-size: 26px;
          font-weight: 700;
          color: #0a2540;
          margin-bottom: 8px;
        }
        .vision .mv-title {
          color: #fff;
        }
        .mv-text {
          font-size: 15px;
          color: #4a5a6a;
          line-height: 1.8;
          margin-bottom: 24px;
        }
        .vision .mv-text {
          color: rgba(255,255,255,.7);
        }
        .mv-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .mv-item {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: #4a5a6a;
          font-weight: 500;
        }
        .mv-bullet {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #c9a227;
          flex-shrink: 0;
        }
        .vision-stats {
          display: flex;
          gap: 32px;
          margin-top: 24px;
        }
        .v-stat {
          text-align: center;
        }
        .v-stat-num {
          font-size: 28px;
          font-weight: 900;
          color: #c9a227;
        }
        .v-stat-label {
          font-size: 11px;
          color: rgba(255,255,255,.5);
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-top: 4px;
        }

        /* ---------- VALEURS ---------- */
        .valeurs-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 24px;
        }
        .val-card {
          padding: 32px 24px;
        }
        .val-icon {
          font-size: 32px;
          margin-bottom: 16px;
        }
        .val-title {
          font-size: 17px;
          font-weight: 700;
          color: #0a2540;
          margin-bottom: 10px;
        }
        .val-desc {
          font-size: 13px;
          color: #4a5a6a;
          line-height: 1.7;
        }

        /* ---------- TIMELINE ---------- */
        .timeline {
          display: flex;
          flex-direction: column;
          gap: 0;
        }
        .timeline-item {
          display: flex;
          align-items: flex-start;
          gap: 0;
          flex: 1;
        }
        .tl-card {
          flex: 1;
          background: #fff;
          border: 1px solid #d8e0e8;
          border-radius: 16px;
          padding: 28px;
          box-shadow: 0 4px 20px rgba(10,37,64,.06);
          margin: 0 24px 40px;
        }
        .tl-year {
          font-size: 22px;
          font-weight: 900;
          margin-bottom: 6px;
        }
        .tl-title {
          font-size: 16px;
          font-weight: 700;
          color: #0a2540;
          margin-bottom: 8px;
        }
        .tl-desc {
          font-size: 13px;
          color: #4a5a6a;
          line-height: 1.7;
        }
        .tl-center {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 24px;
        }
        .tl-dot {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          flex-shrink: 0;
          z-index: 1;
        }
        .tl-line {
          width: 2px;
          background: #d8e0e8;
          flex: 1;
          min-height: 60px;
        }

        /* ---------- TEAM ---------- */
        .team-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }
        .team-card {
          padding: 28px 20px;
          text-align: center;
        }
        .team-avatar {
          width: 64px;
          height: 64px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px;
          font-size: 18px;
          font-weight: 900;
        }
        .team-name {
          font-weight: 700;
          font-size: 15px;
          color: #0a2540;
          margin-bottom: 6px;
        }
        .team-role {
          font-size: 12px;
          color: #8a9aaa;
          font-weight: 500;
        }

        /* ---------- CTA FINAL ---------- */
        .cta-section {
          background: linear-gradient(135deg, #0a2540 0%, #1e3a5f 100%);
        }
        .cta-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(28px, 4vw, 42px);
          font-weight: 700;
          color: #fff;
          margin: 16px 0 12px;
        }
        .cta-sub {
          font-size: 16px;
          color: rgba(255,255,255,.6);
          max-width: 500px;
          margin: 0 auto;
        }

        /* ---------- RESPONSIVE ---------- */
        @media (max-width: 992px) {
          .section { padding: 60px 0; }
          .section-title { font-size: 32px; }
          .team-grid { grid-template-columns: repeat(2, 1fr); }
          .mv-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 768px) {
          .container { padding: 0 20px; }
          .section { padding: 48px 0; }
          .hero-title { font-size: 32px !important; }
          .hero-sub { font-size: 15px !important; }
          .mv-card { padding: 28px 24px !important; }
          .vision-stats { flex-wrap: wrap; gap: 20px !important; }
          .valeurs-grid { grid-template-columns: 1fr !important; }
          .timeline-item { flex-direction: column !important; align-items: stretch !important; }
          .tl-card { margin: 0 0 20px 0 !important; order: 1; }
          .tl-center { order: 2; flex-direction: row !important; justify-content: center; gap: 16px; padding-top: 0 !important; }
          .tl-line { display: none !important; }
          .tl-dot { width: 12px; height: 12px; }
          .team-grid { grid-template-columns: 1fr; gap: 16px; }
          .cta-buttons { flex-direction: column; align-items: stretch; }
          .btn-primary, .btn-outline { width: 100%; text-align: center; }
        }
        @media (max-width: 480px) {
          .section-title { font-size: 28px; }
          .mv-title { font-size: 22px !important; }
          .tl-card { padding: 20px !important; }
        }
      `}</style>
    </div>
  );
}